import { EMOJI_GLYPHS, TONEABLE } from './emoji-data';
import { getTonedGlyph, SKIN_TONE_VALUES } from './emoji-glyph';

interface EmojiIconBody {
	body: string;
}

interface EmojiIconifyJSON {
	prefix: 'emoji';
	width: 24;
	height: 24;
	icons: Record<string, EmojiIconBody>;
}

function makeBody(glyph: string): string {
	return `<foreignObject width="24" height="24"><div xmlns="http://www.w3.org/1999/xhtml" style="display:flex;align-items:center;justify-content:center;width:24px;height:24px;font-size:20px;line-height:1">${glyph}</div></foreignObject>`;
}

export function buildEmojiCollection(): EmojiIconifyJSON {
	const icons: Record<string, EmojiIconBody> = {};

	for (const [shortcode, glyph] of Object.entries(EMOJI_GLYPHS)) {
		icons[shortcode] = { body: makeBody(glyph) };
	}

	for (const shortcode of TONEABLE) {
		for (const tone of SKIN_TONE_VALUES) {
			if (tone === 0) continue;
			icons[`${shortcode}-tone${tone}`] = { body: makeBody(getTonedGlyph(shortcode, tone)) };
		}
	}

	return {
		prefix: 'emoji',
		width: 24,
		height: 24,
		icons,
	};
}
